import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ApiTokenInterceptor } from './api-token-interceptor';

import { CategoryDataHttpProvider } from './category';
import { ChatDataHttpProvider } from './chat';
import { CommentsDataHttpProvider } from './comments';
import { ConfigurationDataHttpProvider } from './configuration';
import { DataHttpCommonServiceProvider } from './data-http-common.service';
import { DataHttpServiceProvider } from './data-http.service-provider';
import { DataSourceHttpProvider } from './data-source';
import { EmailDataHttpProvider } from './email';
import { EpDataHttpProvider } from './ep';
import { FavoritesDataHttpProvider } from './favorites';
import { FileDataHttpProvider } from './file';
import { HistoryDataHttpProvider } from './history';
import { LocalizationDataHttpProvider } from './localization';
import { PortalDataHttpProvider } from './portal';
import { PublicationsDataHttpProvider } from './publications';
import { ReportsDataHttpProvider } from './reports';
import { TaskDataHttpProvider } from './task';
import { TickersDataHttpProvider } from './tickers';
import { UsersDataHttpProvider } from './users';
import { FeedsDataHttpProvider } from './feeds';
import { SurveyDataHttpProvider } from './survey';
import { SystemDataHttpProvider } from './system';
import { SearchDataHttpProvider } from './search';
import { SignaturesHttpProvider } from './signatures';
import { from } from 'rxjs';
import { AuthDataHttpProvider } from './auth';
import { CacheInterceptor, CACHE_REQUEST_CONFIG, ICacheRequestConfig } from './cache-requests';
import { TaskHierarhyHttpProvider } from './task-hierarhy';
import { SubtasksHttpProvider } from './subtasks';
import { LinkedTasksHttpProvider } from './linked-tasks';
import { FiltersDataHttpProvider } from './filters';

@NgModule()
export class DataHttpModule {
	static forRoot(options?: Partial<{ cache: ICacheRequestConfig }>): ModuleWithProviders<DataHttpModule> {
		return {
			ngModule: DataHttpModule,
			providers: [
				DataHttpCommonServiceProvider,
				ChatDataHttpProvider,
				DataHttpServiceProvider,
				FileDataHttpProvider,
				TaskDataHttpProvider,
				PortalDataHttpProvider,
				EpDataHttpProvider,
				UsersDataHttpProvider,
				TickersDataHttpProvider,
				FavoritesDataHttpProvider,
				DataSourceHttpProvider,
				HistoryDataHttpProvider,
				ConfigurationDataHttpProvider,
				LocalizationDataHttpProvider,
				PublicationsDataHttpProvider,
				EmailDataHttpProvider,
				ReportsDataHttpProvider,
				CommentsDataHttpProvider,
				CategoryDataHttpProvider,
				FeedsDataHttpProvider,
				SurveyDataHttpProvider,
				SystemDataHttpProvider,
				SearchDataHttpProvider,
				SignaturesHttpProvider,
				AuthDataHttpProvider,
				FiltersDataHttpProvider,
				{
					provide: HTTP_INTERCEPTORS,
					useClass: ApiTokenInterceptor,
					multi: true,
				},
				{
					provide: CACHE_REQUEST_CONFIG,
					useValue: options?.cache || {},
				},
				{
					provide: HTTP_INTERCEPTORS,
					useClass: CacheInterceptor,
					multi: true,
				},
				TaskHierarhyHttpProvider,
				SubtasksHttpProvider,
				LinkedTasksHttpProvider,
			],
		};
	}
}
